import { BG_INPUT_RACE } from 'assets/images'
import styled from 'styled-components'

interface SelectDatePickerStyled {
  customClass?: string
}

const SelectDatePickerStyled = styled.div<SelectDatePickerStyled>`
  background: url(${BG_INPUT_RACE});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 40px;
  padding: 2px 16px 2px 4px;
  cursor: pointer;

  > div {
    height: 38px;
  }

  .orange-line {
    left: 12px;
    bottom: 21px;
    width: 70px;
    height: 3px;
  }

  .calendar {
    position: absolute;
    top: 36px;
    right: 27px;
  }

  .time-calendar {
    position: absolute;
    line-height: 32px;
    padding: 2px 11px;
    background-color: transparent;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    width: 100%;
    height: 40px;
  }
  .cursor-pointer {
    cursor: pointer;
  }

  .react-datepicker {
    z-index: 99;
    bottom: 250px;
    .react-datepicker__month-container{
      .react-datepicker__header {
        button {
          height: 30px;
        }
        p {
          margin-top: 5px;
          padding-left: 5px;
          padding-right: 5px;
        }
      }
    }
  }
`
export default SelectDatePickerStyled
